module.exports = __webpack_public_path__ + "img/FjfaL3kHpTWemywA-XM508a1uGBI.8fb2f75c.png";